const BREADSTICKS_ID = '1sPBwXDFrAOqrzGuOTrO-g';
const CINNAMON_STICKS_ID = 'XGTOSKt_WYMrMHE_5Hx7eg';

export const optimizelyRecipeIds = [BREADSTICKS_ID, CINNAMON_STICKS_ID];

const LITERACY_DONATION_RECIPE_ID = '1-03mGJO8eQWp5gbh6mIV3gB43mTLTzfe0HMLopIpwM';
const LITERACY_DONATION_RECIPE_ID_YUM = 'CLSS110PA|PROD1061L';

export const autoAddingRecipeIds = [LITERACY_DONATION_RECIPE_ID, LITERACY_DONATION_RECIPE_ID_YUM];
